import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import { requests } from '.'

// use serviceName value below as key in `versions` object in `src/config/services.ts` for developer versions
const serviceName = 'ChatWidgetService'
const host = servicesConfig.ChatWidget
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

const ChatWidgetService = {
  getCode: ({locationId, isGTM = false, widgetId}:{locationId: string, isGTM: boolean, widgetId?: string}) => {
    const params:any = {
      isGTM
    }
    if (widgetId) params.widgetId = widgetId
    return request().get(`/code/${locationId}`, { params })
  },

  getSettings: ({
    locationId,
    widgetId,
  }: {
    locationId: string
    widgetId: string
  }) => request().get(`data/${locationId}/${widgetId}`),

  updateSettings: ({
    locationId,
    widgetId,
    settings,
  }: {
    locationId: string
    widgetId: string
    settings: any
  }) => request().put(`data/${locationId}/${widgetId}`, settings),
}

export default ChatWidgetService
